export function AuthenticatorAppIcon() {
  return (
    <svg
      preserveAspectRatio="none"
      overflow="visible"
      style={{ display: 'block' }}
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Authenticator app</title>
      <g>
        <path
          d="M8 1C8.55228 1 9 1.44772 9 2V14C9 14.5523 8.55229 15 8 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H8ZM2 0C0.895431 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H8C9.10457 16 10 15.1046 10 14V2C10 0.895431 9.10457 0 8 0H2Z"
          fill="#363636"
        />
        <path
          d="M5 14C5.55228 14 6 13.5523 6 13C6 12.4477 5.55228 12 5 12C4.44772 12 4 12.4477 4 13C4 13.5523 4.44772 14 5 14Z"
          fill="#363636"
        />
      </g>
    </svg>
  );
}

export function SmsMethodIcon() {
  return (
    <svg
      preserveAspectRatio="none"
      overflow="visible"
      style={{ display: 'block' }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Text message</title>
      <g>
        <path
          d="M6.25 10C6.25 10.6904 5.69036 11.25 5 11.25C4.30964 11.25 3.75 10.6904 3.75 10C3.75 9.30964 4.30964 8.75 5 8.75C5.69036 8.75 6.25 9.30964 6.25 10Z"
          fill="#363636"
        />
        <path
          d="M11.25 10C11.25 10.6904 10.6904 11.25 10 11.25C9.30964 11.25 8.75 10.6904 8.75 10C8.75 9.30964 9.30964 8.75 10 8.75C10.6904 8.75 11.25 9.30964 11.25 10Z"
          fill="#363636"
        />
        <path
          d="M15 11.25C15.6904 11.25 16.25 10.6904 16.25 10C16.25 9.30964 15.6904 8.75 15 8.75C14.3096 8.75 13.75 9.30964 13.75 10C13.75 10.6904 14.3096 11.25 15 11.25Z"
          fill="#363636"
        />
        <path
          d="M2.70583 19.7537L2.73112 19.7487C5.01792 19.2954 6.41671 18.6964 7.06605 18.3674C7.99385 18.6161 8.97906 18.75 10 18.75C15.5228 18.75 20 14.8325 20 10C20 5.16751 15.5228 1.25 10 1.25C4.47715 1.25 0 5.16751 0 10C0 12.2011 0.928827 14.2124 2.46223 15.7501C2.36996 16.7139 2.11778 17.748 1.8081 18.6476L1.80323 18.6618C1.76556 18.7708 1.72705 18.8779 1.68788 18.9826C1.62621 19.1474 1.56292 19.3064 1.49872 19.458C1.40046 19.6902 1.59088 19.9504 1.83965 19.9097C2.0158 19.8808 2.1875 19.851 2.35477 19.8204C2.47403 19.7986 2.59104 19.7763 2.70583 19.7537ZM3.70654 15.8692C3.74204 15.4985 3.61035 15.1312 3.34736 14.8674C2.02163 13.538 1.25 11.8351 1.25 10C1.25 6.00943 5.0055 2.5 10 2.5C14.9945 2.5 18.75 6.00943 18.75 10C18.75 13.9906 14.9945 17.5 10 17.5C9.08845 17.5 8.21208 17.3805 7.38978 17.16C7.09227 17.0802 6.77578 17.1131 6.50102 17.2523C6.01697 17.4976 4.95208 17.9651 3.20846 18.3681C3.44377 17.5648 3.62699 16.7001 3.70654 15.8692Z"
          fill="#363636"
        />
      </g>
    </svg>
  );
}

export function PasskeyMethodIcon() {
  return (
    <svg
      preserveAspectRatio="none"
      overflow="visible"
      style={{ display: 'block' }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Passkey</title>
      <g>
        <path
          d="M0 10C0 7.23858 2.23858 5 5 5C6.8516 5 8.46705 6.00649 9.33095 7.5H17.5C17.6658 7.5 17.8247 7.56585 17.9419 7.68306L19.8169 9.55806C20.061 9.80214 20.061 10.1979 19.8169 10.4419L17.9419 12.3169C17.6979 12.561 17.3021 12.561 17.0581 12.3169L16.25 11.5089L15.4419 12.3169C15.1979 12.561 14.8021 12.561 14.5581 12.3169L13.75 11.5089L12.9419 12.3169C12.6979 12.561 12.3021 12.561 12.0581 12.3169L11.25 11.5089L10.4419 12.3169C10.3247 12.4342 10.1658 12.5 10 12.5H9.33095C8.46705 13.9935 6.8516 15 5 15C2.23858 15 0 12.7614 0 10ZM5 6.25C2.92893 6.25 1.25 7.92893 1.25 10C1.25 12.0711 2.92893 13.75 5 13.75C6.49499 13.75 7.7869 12.8752 8.38944 11.6068C8.49297 11.3889 8.7127 11.25 8.95398 11.25H9.74112L10.8081 10.1831C11.0521 9.93898 11.4479 9.93898 11.6919 10.1831L12.5 10.9911L13.3081 10.1831C13.5521 9.93898 13.9479 9.93898 14.1919 10.1831L15 10.9911L15.8081 10.1831C16.0521 9.93898 16.4479 9.93898 16.6919 10.1831L17.5 10.9911L18.4911 10L17.2411 8.75H8.95398C8.7127 8.75 8.49297 8.61112 8.38944 8.39318C7.7869 7.12479 6.49499 6.25 5 6.25Z"
          fill="#121212"
        />
        <path
          d="M5 10C5 10.6904 4.44036 11.25 3.75 11.25C3.05964 11.25 2.5 10.6904 2.5 10C2.5 9.30964 3.05964 8.75 3.75 8.75C4.44036 8.75 5 9.30964 5 10Z"
          fill="#121212"
        />
      </g>
    </svg>
  );
}

export function EmailCodeMethodIcon() {
  return (
    <svg
      preserveAspectRatio="none"
      overflow="visible"
      style={{ display: 'block' }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Email code</title>
      <g>
        <path
          d="M4 0C2.89543 0 2 0.895431 2 2V3.13328L1.05882 3.63525C0.407097 3.98283 0 4.66133 0 5.39995V14C0 15.1045 0.895431 16 2 16H14C15.1046 16 16 15.1045 16 14V5.39995C16 4.66133 15.5929 3.98283 14.9412 3.63525L14 3.13328V2C14 0.895431 13.1046 0 12 0H4ZM14 4.26662L14.4706 4.5176C14.7965 4.69139 15 5.03064 15 5.39995V6.21686L14 6.81686V4.26662ZM13 7.41686L9.25 9.66686L8 8.91686L6.75 9.66686L3 7.41686V2C3 1.44772 3.44772 1 4 1H12C12.5523 1 13 1.44772 13 2V7.41686ZM2 6.81686L1 6.21686V5.39995C1 5.03064 1.20355 4.69139 1.52941 4.5176L2 4.26662V6.81686ZM15 7.38305V13.1169L10.2218 10.25L15 7.38305ZM14.9653 14.2622C14.85 14.6873 14.4615 15 14 15H2C1.53846 15 1.14995 14.6873 1.03474 14.2622L8 10.083L14.9653 14.2622ZM1 13.1169V7.38305L5.77817 10.25L1 13.1169Z"
          fill="#363636"
        />
      </g>
    </svg>
  );
}
